import React from "react";
import aboutImg from "../../assets/webimgs/about.webp";
import { Link } from "react-router-dom";

function Story() {
  return (
    <section className="w-full bg-gray-200 dark:bg-gray-800 my-16 py-16">
      <div className="m-auto p-8 lg:w-[80%]">
        <h1 className="text-[32px] md:text-[40px] lg:text-[48px] text-transparent bg-clip-text bg-gradient-to-t from-gray-700 to-gray-300 hover:from-gray-300 hover:to-gray-700  font-ten tracking-tight font-extrabold">
          Our Story
        </h1>
        <div className="flex mt-10 flex-col-reverse lg:flex-row gap-8 dark:text-white">
          <div className="flex flex-col gap-4 lg:w-[50%] w-full justify-center">
            <p className="font-ten text-[16px] md:text-[18px]  font-semibold text-left">
              Welcome to Konduti Stones,{" "}
              <span className="font-medium text-[14px] md:text-[16px]">
                where the raw beauty of the earth meets the vision of
                exceptional design.
              </span>
            </p>
            <p className="font-ten text-[14px] md:text-[16px] font-medium text-left">
              For a long time, we have been more than just a stone
              supplier; we are stewards of the natural world and partners in
              your most ambitious projects. Our business is built on a
              comprehensive, vertically integrated approach, giving us unrivaled
              control over quality from the moment the stone is unearthed to the
              final delivery.
            </p>
            <p className="font-ten text-[14px] md:text-[16px] font-medium text-left">
              Our unique strength lies in our deep connection to the source. We
              own and operate dedicated quarries for the responsible mining of
              premium limestone and high-quality boulders. This direct
              involvement ensures two things: a consistent supply of superior
              raw material and a commitment to sustainable practices
            </p>

            <p className="font-ten text-[14px]">
              {" "}
              Want to Know more about us?{" "}
              <Link
                to={"/about"}
                className="text-blue-500 font-semibold hover:underline"
              >
                Learn More
              </Link>
            </p>
          </div>
          <div className="relative lg:w-[50%] w-full group">
            {/* Background box */}
            <div className="absolute top-0 left-0 w-full h-full shadow-lg dark:shadow-slate-900 border-2 border-black dark:border-slate-200  translate-x-3 translate-y-3 transition-all duration-500 group-hover:translate-x-0 group-hover:translate-y-0"></div>

            {/* Image */}
            <img
              src={aboutImg}
              alt="About Konduti Stones"
              className="relative w-full h-full object-cover  shadow-lg transition-all duration-500 group-hover:translate-x-3 group-hover:translate-y-3"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Story;
